import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactLoading from 'react-loading'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Button from 'components/Button'

import { CLAIM_NOTES } from 'constants'

import NewNote from './NewNote'
import NoteList from './NoteList'

import { notesFetched } from './actions'

import './styles.scss'

export class Notes extends BaseComponent {
  constructor() {
    super()

    this._bind('_renderNotes', '_showModal', '_fetchNotes')
  }

  componentDidMount() {
    this._fetchNotes()
  }

  _fetchNotes() {
    request(CLAIM_NOTES(this.props.claimId))
      .then(({notes}) => {
        this.props.notesFetched(notes)
      })
      .catch((err) => {console.log(err)})
  }

  _renderNotes() {
    if(this.props.notes_list.length === undefined) {
      return (
        <ReactLoading id="Spin" type={'spin'} color={'#444'}  />
      )
    } else {
      return this.props.notes_list.length > 0 ? (
        <NoteList notes={this.props.notes_list}/>
      ) : (<p className="message">No hay ninguna nota aún</p> )
    }
  }

  _showModal() {
    this.context.toggleModal(true,
      <NewNote claimId={this.props.claimId}/>
    )
  }

  render() {
    return (
      <div className="SinisterNotes">
        <div className="SinisterNotes__head d-flex align-items-center">
          <h1>Notas</h1>
          <Button className="justify-content-center" onClick={this._showModal} buttonType="primary" size="label">
            <i className="material-icons">add</i>
            Crear nueva
          </Button>
        </div>
        <div className="SinisterNotes__list">
          {this._renderNotes()}
        </div>
      </div>
    )
  }
}


Notes.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
}


const mapStateToProps = (state) => {
  return {
    notes_list: state.claimNotes.get('notes_list')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    notesFetched: (notification_list) => dispatch(notesFetched(notification_list))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Notes)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notes/index.js